import { STORE_SERVICES } from '../../../../../views/phone-answering/constants';

export default {
  title: 'Services',
  options: {
    [STORE_SERVICES.CATERING]: 'Traiteur',
    [STORE_SERVICES.TERRACE]: 'Terrasse disponible',
    [STORE_SERVICES.DINE_IN]: 'Sur place',
    [STORE_SERVICES.ONLINE_ORDERING]: 'Commande en ligne via FoodAmigos',
    [STORE_SERVICES.RESERVATION]: 'Réservations via FoodAmigos',
    [STORE_SERVICES.INTERNAL_RESERVATION]: 'Réservations en restaurant',
  },
  labels: {
    reservation_total_seats: 'Places totales (réservation)',
    catering_min_people: 'Personnes min. (traiteur)',
  },
};
